<template>
  <div class="app-container">
    <div>
      <!-- <div class="detailsTitle">
        <h4>计重方式配置</h4>
      </div> -->
      <div>
        <div class="formBox margbot" ref="searchBox">
          <el-form style="padding-left: 10px;">
            <el-form-item>
              <el-button type="primary" @click="xinzeng" size="mini" btnCode="00ZP00HB001" v-if="btnFlg[0]">新增</el-button>
              <el-button type="primary" @click="xiugai" size="mini" btnCode="00ZP00HB002" v-if="btnFlg[1]">修改</el-button>
              <el-button type="primary" @click="shanchu" size="mini" btnCode="00ZP00HB003" v-if="btnFlg[2]">删除</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="tableClass" :style="{ height: h}">
          <el-table ref="table" size="mini" :data="tableData" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @row-click="dianjixuanzhong" height="100%" style="width:100%" border center bordersize="mini" class="tableComent">
            <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
            <el-table-column prop="productTypeName" label="货物类型" align="center"></el-table-column>
            <el-table-column prop="inWeighingMethodName" label="入库计重方式" align="center"></el-table-column>
            <el-table-column prop="inPoundMethodName" label="入库过磅方式" align="center"></el-table-column>
            <el-table-column prop="outWeighingMethodName" label="出库计重方式" align="center"></el-table-column>
            <el-table-column prop="outPoundMethodName" label="出库过磅方式" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="pags" style="text-align: left">
          <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ"></el-pagination>
        </div>
      </div>
    </div>
    <div class="JZfangshi">
      <el-dialog :title="JZTitle" :visible.sync="XZVisible" :close-on-click-modal="false" width="40%" center @close="closeJZDialog">
        <el-form :model="addFormData" ref="addFormData" label-width="250px" class="demo-dynamic">
          <el-form-item prop="productType" label="货物类型" :rules="[
        {
          required: true,
          message: '请选择货物类型',
          trigger: 'change',
        }
        ]">
            <el-select v-model="addFormData.productType" size="mini" placeholder="请选择货物类型">
              <el-option v-for="item in productTypeName" :key="item.itemNo" :label="item.showName" :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="inWeighingMethod" label="入库计重方式" :rules="[
        {
          required: true,
          message: '请选择入库计重方式',
          trigger: 'change',
        }
        ]">
            <el-select v-model="addFormData.inWeighingMethod" size="mini" @change="inWeighingMethodChange" placeholder="请选择入库计重方式">
              <el-option v-for="item in JZData" :key="item.itemNo" :label="item.showName" :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="inPoundMethod" label="入库过磅方式" :rules="[
        {
          required: true,
          message: '请选择入库过磅方式',
          trigger: 'change',
        }
        ]">
            <el-select v-model="addFormData.inPoundMethod" size="mini" placeholder="请选择入库过磅方式">
              <el-option v-for="item in GBData" v-show="addFormData.inWeighingMethod==1||(addFormData.inWeighingMethod==2&&item.itemNo!=3)||(addFormData.inWeighingMethod==3&&item.itemNo!=3)" :key="item.itemNo" :label="item.showName" :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="outWeighingMethod" label="出库计重方式" :rules="[
        {
          required: true,
          message: '请选择出库计重方式',
          trigger: 'change',
        }
        ]">
            <el-select v-model="addFormData.outWeighingMethod" size="mini" @change="outWeighingMethodChange" placeholder="请选择出库计重方式">
              <el-option v-for="item in CKJZData" :key="item.itemNo" :label="item.showName" :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="outPoundMethod" label="出库过磅方式" :rules="[
          {
            required: true,
            message: '请选择出库过磅方式',
            trigger: 'change',
          }
          ]">
            <el-select v-model="addFormData.outPoundMethod" size="mini" placeholder="请选择出库过磅方式">
              <el-option v-for="item in CKGBData" v-show="addFormData.outWeighingMethod==1||(addFormData.outWeighingMethod==2&&item.itemNo!=3)" :key="item.itemNo" :label="item.showName" :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="width: 180px; margin: 15px auto">
          <el-button @click="closeJZDialog">取消</el-button>
          <el-button type="primary" @click="addJZDialog" :loading="JZLoading">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getWeighingMethodList, addOrUpdateWeighingMeth, getWeighingMethodPopup, deleteWeighingMethod } from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      JZLoading: false,
      btnArr: [
        '00ZP00HB001',
        '00ZP00HB002',
        '00ZP00HB003'
      ],
      btnFlg: [],
      h: '400px',
      tableData: [],
      JZTitle: '',
      XZVisible: false,
      addFormData: {
        productType: '',
        inWeighingMethod: '',
        inPoundMethod: '',
        outWeighingMethod: '',
        outPoundMethod: ''
      },
      productTypeName: [],
      JZData: [],
      GBData: [],
      CKJZData: [],
      CKGBData: [],
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      totalXQ: 0,
      xuanzhongArr: null,
      messages: '添加成功'
    }
  },
  methods: {
    initForm () {
      this.addFormData.productType = ''
      this.addFormData.inWeighingMethod = ''
      this.addFormData.inPoundMethod = ''
      this.addFormData.outWeighingMethod = ''
      this.addFormData.outPoundMethod = ''
      this.addFormData.weighingMethodId = ''
      this.xuanzhongArr = null
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    xinzeng () {
      this.XZVisible = true
      this.JZLoading = false
      this.JZTitle = '新增计重方式'
      this.messages = '添加成功'
      this.getWeighingMethodPopups()
      this.addFormData.productType = ''
      this.addFormData.inWeighingMethod = ''
      this.addFormData.inPoundMethod = ''
      this.addFormData.outWeighingMethod = ''
      this.addFormData.outPoundMethod = ''
      this.addFormData.weighingMethodId = ''
      this.$nextTick(() => {
        this.$refs.addFormData.clearValidate()
      })
    },
    xiugai () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.XZVisible = true

      this.JZLoading = false
      this.$nextTick(() => {
        this.$refs.addFormData.clearValidate()
      })
      this.JZTitle = '修改计重方式'
      this.messages = '修改成功'
      this.addFormData.productType = this.xuanzhongArr.productType
      this.addFormData.inWeighingMethod = this.xuanzhongArr.inWeighingMethod
      this.addFormData.inPoundMethod = this.xuanzhongArr.inPoundMethod
      this.addFormData.outWeighingMethod = this.xuanzhongArr.outWeighingMethod
      this.addFormData.outPoundMethod = this.xuanzhongArr.outPoundMethod
      this.addFormData.weighingMethodId = this.xuanzhongArr.weighingMethodId
      this.getWeighingMethodPopups()
    },
    shanchu () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteWeighingMethod(
          {
            weighingMethodIds: this.xuanzhongArr.weighingMethodId
          }
        )
          .then(res => {
            DonMessage.success('删除成功')
            that.getWeighingMethodLists()
            this.xuanzhongArr = null
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
        // this.saveFn()
      })
    },
    addJZDialog () {
      this.$refs.addFormData.validate((valid) => {
        if (valid) {
          this.JZLoading = true
          this.addOrUpdateWeighingMeths()
        } else {
          this.JZLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    closeJZDialog () {
      this.XZVisible = false
      this.$refs.addFormData.resetFields()
      // this.initForm()
    },
    handleCurrentChangeXQ (val) {
      this.pageInfo.pageNo = val
      this.getWeighingMethodLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfo.pageSize = val
      this.getWeighingMethodLists()
    },
    inWeighingMethodChange () {
      this.addFormData.inPoundMethod = ''
      this.$set(this.addFormData, 'inPoundMethod', '')
    },
    outWeighingMethodChange () {
      this.addFormData.outPoundMethod = ''
    },
    getWeighingMethodPopups () {
      getWeighingMethodPopup().then(res => {
        // console.log(res);
        this.productTypeName = res.threadProductTypeList
        this.JZData = res.threadInstockWeightTypeList
        this.GBData = res.threadInstockPoundWeightTypeList
        this.CKGBData = res.threadOutstockPoundWeightTypeList
        this.CKJZData = res.threadOutstockWeightTypeList
      })
    },
    addOrUpdateWeighingMeths () {
      // this.addFormData.weighingMethodId =
      this.addFormData.productTypeName = this.productTypeName.filter(item => item.itemNo == this.addFormData.productType)[0].showName
      this.addFormData.inWeighingMethodName = this.JZData.filter(item => item.itemNo == this.addFormData.inWeighingMethod)[0].showName
      this.addFormData.outWeighingMethodName = this.CKJZData.filter(item => item.itemNo == this.addFormData.outWeighingMethod)[0].showName
      this.addFormData.inPoundMethodName = this.GBData.filter(item => item.itemNo == this.addFormData.inPoundMethod)[0].showName
      this.addFormData.outPoundMethodName = this.CKGBData.filter(item => item.itemNo == this.addFormData.outPoundMethod)[0].showName

      addOrUpdateWeighingMeth(this.addFormData)
        .then(res => {
          this.XZVisible = false
          DonMessage.success(this.messages)
          this.getWeighingMethodLists()
          this.initForm()
        })
        .catch(error => {
          this.JZLoading = false
          DonMessage.error(error.message)
        })
    },
    getWeighingMethodLists () {
      getWeighingMethodList({ ...this.pageInfo })
        .then(res => {
          console.log(res)
          this.tableData = res.list

          this.totalXQ = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/measurementConfig')
  },
  mounted () {
    this.getWeighingMethodLists()
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
  }

}
</script>

<style lang="less" scoped>
.tableClass {
  max-height: calc(100vh - 200px);
  overflow: auto;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 22px;
  }
  /deep/.el-input__inner {
    width: 100px !important;
  }
}
</style>
